/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Resource Explorer Service API
 * OpenAPI spec version: 0.1.0
 */
import {CategoryIconID} from './category-icon-id';
import {ResourceIconID} from './resource-icon-id';

export const IconResponseId = {...ResourceIconID, ...CategoryIconID} as const;
